import { render, staticRenderFns } from "./CustomersVessels.vue?vue&type=template&id=5540c028&scoped=true"
import script from "./CustomersVessels.vue?vue&type=script&lang=js"
export * from "./CustomersVessels.vue?vue&type=script&lang=js"
import style0 from "./CustomersVessels.vue?vue&type=style&index=0&id=5540c028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5540c028",
  null
  
)

export default component.exports